interface AuthUser {
  roles: string[]; // Ensure roles is explicitly typed as an array of strings
}

export default defineNuxtRouteMiddleware((to, from) => {
  // Get the required role from route meta
  const requiredRole = to.meta.requiredRole;

  // If no role is required, allow access
  if (!requiredRole) {
    return;
  }

  // Get the user from auth state (assuming you're using the same auth approach as your example)
  const user = useSanctumUser() as Ref<AuthUser | null>;

  // If no user is authenticated, redirect to login
  if (!user) {
    return navigateTo('/auth/login');
  }

  // Check if the user has the required role
  const hasRequiredRole = user?.value?.roles?.includes(requiredRole as string);

  // If the user doesn't have the required role, redirect to access denied page
  if (!hasRequiredRole) {
    return navigateTo('/vdp/access-denied', { replace: true });
  }
});
